/* Wishlist for the minery-* sections.

   There is no wishlist app installed, so this keeps the list in the
   browser's localStorage. That means it is per-device and per-browser: it
   survives reloads and return visits on the same phone or laptop, but it
   does not follow a customer to another device and it is not visible in the
   Shopify admin. Swapping in a real app later means replacing this file, not
   the markup — every heart already carries data-wishlist-add and
   data-product-handle.

   Product details are read from /products/{handle}.js the first time an item
   is saved and then cached in the stored record, so opening the panel costs
   no requests. */

(function () {
  'use strict';

  var KEY = 'minery:wishlist';
  var items = [];
  var panel = null;

  /* ----------------------------------------------------------------------
     Store
     ---------------------------------------------------------------------- */

  function load() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(KEY));
      items = Array.isArray(raw) ? raw.filter(function (i) { return i && i.handle; }) : [];
    } catch (err) {
      items = [];
    }
  }

  function save() {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (err) {
      /* private mode or storage full — the list still works for this page */
    }
  }

  function has(handle) {
    return items.some(function (i) { return i.handle === handle; });
  }

  function find(handle) {
    return items.filter(function (i) { return i.handle === handle; })[0];
  }

  /* ----------------------------------------------------------------------
     Formatting
     ---------------------------------------------------------------------- */

  function money(cents, currency) {
    if (typeof cents !== 'number') return '';
    try {
      // Whole rupees print without ".00", matching every Liquid price on the
      // site (the store formats amounts without trailing zeros).
      var digits = cents % 100 === 0 ? 0 : 2;
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2);
    }
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  /* ----------------------------------------------------------------------
     Rendering
     ---------------------------------------------------------------------- */

  function icon(path, width) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', width || '1.7');
    svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', path);
    svg.appendChild(p);
    return svg;
  }

  function row(item, currency, removeLabel) {
    var li = document.createElement('li');
    li.className = 'm-wish__item';

    var media = document.createElement('a');
    media.className = 'm-wish__media';
    media.href = item.url || '#';
    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    li.appendChild(media);

    var info = document.createElement('div');
    info.className = 'm-wish__info';

    var title = document.createElement('a');
    title.className = 'm-wish__name';
    title.href = item.url || '#';
    title.textContent = item.title || item.handle;
    info.appendChild(title);

    if (typeof item.price === 'number') {
      var price = document.createElement('p');
      price.className = 'm-wish__price';
      price.textContent = money(item.price, currency);
      info.appendChild(price);
    }

    li.appendChild(info);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'm-wish__remove';
    remove.setAttribute('data-m-wish-remove', item.handle);
    remove.setAttribute('aria-label', (removeLabel || 'Remove') + ' ' + (item.title || item.handle));
    remove.appendChild(icon('M6 6l12 12M18 6L6 18'));
    li.appendChild(remove);

    return li;
  }

  /* ----------------------------------------------------------------------
     Save animation

     Same shape as the Framer Motion original: one radial burst plus five
     particles on a circle, each with its own radius, scale and duration and
     a 40ms stagger. The vertical radius is three quarters of the horizontal
     one, which is what gives the spray its slight flattening.

     Rendered into a fixed layer on <body> because the card tile clips its
     own contents and would cut the particles in half.
     ---------------------------------------------------------------------- */

  function reducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function burst(btn) {
    if (reducedMotion()) return;

    var rect = btn.getBoundingClientRect();
    if (!rect.width && !rect.height) return;

    // A heart inside an open modal dialog (the quick view) draws its burst
    // inside that dialog. A modal sits in the top layer, above anything on
    // <body> whatever its z-index, so a burst there played unseen behind it.
    var host = (btn.closest && btn.closest('dialog[open]')) || document.body;

    var fx = document.createElement('div');
    fx.className = 'm-wish-fx';
    if (host === document.body) {
      fx.style.left = rect.left + rect.width / 2 + 'px';
      fx.style.top = rect.top + rect.height / 2 + 'px';
    } else {
      var box = host.getBoundingClientRect();
      fx.style.position = 'absolute';
      fx.style.left = rect.left - box.left + rect.width / 2 + 'px';
      fx.style.top = rect.top - box.top + rect.height / 2 + 'px';
    }

    var ring = document.createElement('span');
    ring.className = 'm-wish-fx__burst';
    fx.appendChild(ring);

    for (var i = 0; i < 5; i++) {
      var angle = (i / 5) * (2 * Math.PI);
      var radius = 18 + Math.random() * 8;
      var particle = document.createElement('span');
      particle.className = 'm-wish-fx__p';
      particle.style.setProperty('--m-p-x', (Math.cos(angle) * radius).toFixed(1) + 'px');
      particle.style.setProperty('--m-p-y', (Math.sin(angle) * radius * 0.75).toFixed(1) + 'px');
      particle.style.setProperty('--m-p-scale', (0.8 + Math.random() * 0.4).toFixed(2));
      particle.style.setProperty('--m-p-dur', (0.6 + Math.random() * 0.1).toFixed(2) + 's');
      particle.style.setProperty('--m-p-delay', (i * 0.04).toFixed(2) + 's');
      particle.style.setProperty('--m-p-size', (4 + Math.random() * 2).toFixed(1) + 'px');
      fx.appendChild(particle);
    }

    host.appendChild(fx);
    window.setTimeout(function () {
      if (fx.parentNode) fx.parentNode.removeChild(fx);
    }, 1000);
  }

  function popCount() {
    if (reducedMotion()) return;
    document.querySelectorAll('[data-m-wish-count]').forEach(function (el) {
      el.classList.remove('is-pop');
      // reading offsetWidth restarts the animation when saves come quickly
      void el.offsetWidth;
      el.classList.add('is-pop');
    });
  }

  function syncButtons(scope) {
    (scope || document).querySelectorAll('[data-wishlist-add]').forEach(function (btn) {
      var on = has(btn.dataset.productHandle);
      btn.classList.toggle('is-saved', on);
      // aria-pressed carries the state, so the label can stay constant and
      // keep working in any language the merchant translates it into.
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function render() {
    syncButtons();

    document.querySelectorAll('[data-m-wish-count]').forEach(function (el) {
      el.textContent = String(items.length);
      el.hidden = items.length === 0;
    });

    if (!panel) return;

    var list = panel.querySelector('[data-m-wish-list]');
    var empty = panel.querySelector('[data-m-wish-empty]');
    if (!list) return;

    var currency = panel.dataset.currency;
    var removeLabel = panel.dataset.removeLabel || 'Remove';

    list.textContent = '';
    items.forEach(function (item) {
      list.appendChild(row(item, currency, removeLabel));
    });

    if (empty) empty.hidden = items.length > 0;
  }

  /* ----------------------------------------------------------------------
     Panel
     ---------------------------------------------------------------------- */

  function isOpen() {
    return panel && !panel.hidden;
  }

  function open() {
    if (!panel) return;
    panel.hidden = false;
    document.querySelectorAll('[data-m-wishtoggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
  }

  function close() {
    if (!panel) return;
    panel.hidden = true;
    document.querySelectorAll('[data-m-wishtoggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  /* ----------------------------------------------------------------------
     Add / remove
     ---------------------------------------------------------------------- */

  function remove(handle) {
    items = items.filter(function (i) { return i.handle !== handle; });
    save();
    render();
  }

  function add(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;

    // Save straight away so the heart responds to the tap, then fill in the
    // details when the product JSON comes back.
    items.push({
      handle: handle,
      id: btn.dataset.productId || null,
      title: btn.dataset.productTitle || handle,
      url: '/products/' + handle,
      image: null,
      price: null
    });
    save();
    render();
    burst(btn);
    popCount();

    // The panel is deliberately not opened here. Saving happens while someone
    // is part-way down a grid, and throwing a dropdown over the top right of
    // the page interrupts that for no gain — the heart filling red and the
    // count badge bumping already confirm the save. The panel opens when the
    // header icon is clicked, which is the only moment it was actually asked for.

    window
      .fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then(function (product) {
        var record = find(handle);
        if (!record) return;
        record.id = product.id;
        record.title = product.title;
        record.url = product.url;
        record.price = product.price;
        record.image = thumb(product.featured_image);
        save();
        render();
      })
      .catch(function () {
        /* the entry stays with its handle-derived title and link */
      });
  }

  function toggle(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    if (has(handle)) {
      remove(handle);
    } else {
      add(btn);
    }
  }

  /* ----------------------------------------------------------------------
     Wiring
     ---------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var heart = target.closest('[data-wishlist-add]');
    if (heart) {
      event.preventDefault();
      toggle(heart);
      return;
    }

    var removeBtn = target.closest('[data-m-wish-remove]');
    if (removeBtn) {
      event.preventDefault();
      remove(removeBtn.getAttribute('data-m-wish-remove'));
      return;
    }

    if (target.closest('[data-m-wish-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var toggleBtn = target.closest('[data-m-wishtoggle]');
    if (toggleBtn) {
      event.preventDefault();
      if (isOpen()) close(); else open();
      return;
    }

    // click anywhere else dismisses the panel
    if (isOpen() && !target.closest('[data-m-wish]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) close();
  });

  // Saved in another tab — keep this one in step.
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    load();
    render();
  });

  function boot(scope) {
    panel = document.querySelector('[data-m-wish]') || panel;
    load();
    render();
    if (scope) syncButtons(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
